// NBN Product Page Enhancements - Trust Badges
(function() {
  'use strict';

  const BADGES_HTML = `
    <div class="nbn-badges" style="display:flex;gap:12px;justify-content:center;flex-wrap:wrap;padding:12px 0 8px;margin-top:8px;border-top:1px solid rgba(0,0,0,0.08);">
      <div style="text-align:center;font-size:11px;color:#616161;line-height:1.3;min-width:64px;">
        <div style="font-size:16px;margin-bottom:3px;">🔒</div>
        <div>Plain packaging</div>
      </div>
      <div style="text-align:center;font-size:11px;color:#616161;line-height:1.3;min-width:64px;">
        <div style="font-size:16px;margin-bottom:3px;">🧾</div>
        <div>Discreet billing</div>
      </div>
      <div style="text-align:center;font-size:11px;color:#616161;line-height:1.3;min-width:64px;">
        <div style="font-size:16px;margin-bottom:3px;">🚀</div>
        <div>Fast dispatch</div>
      </div>
      <div style="text-align:center;font-size:11px;color:#616161;line-height:1.3;min-width:64px;">
        <div style="font-size:16px;margin-bottom:3px;">🛡️</div>
        <div>1+ yr warranty</div>
      </div>
    </div>`;

  function injectBadges() {
    if (document.querySelector('.nbn-badges')) return;

    // Inject after the entire product-add-to-cart-container (below ATC button)
    const container = document.querySelector('.product-add-to-cart-container');
    if (!container) return;

    const badgesDiv = document.createElement('div');
    badgesDiv.innerHTML = BADGES_HTML;
    container.insertAdjacentElement('afterend', badgesDiv.firstElementChild);
  }

  const SEARCH_PROMPTS = [
    { label: 'Best vibrators for beginners', query: 'Best vibrators for beginners' },
    { label: "Best men's sex toys", url: '/collections/male-masturbators?sort_by=best-selling' },
    { label: 'Couples toys', query: 'Couples toys' },
    { label: 'Beginner anal toys', query: 'Beginner anal toys' },
    { label: 'Quiet vibrators', query: 'Quiet vibrators' },
    { label: 'Lube for sensitive skin', query: 'Lube for sensitive skin' }
  ];

  const SEARCH_PLACEHOLDERS = [
    'Search "gift for wife"'
  ];

  function buildSearchUrl(prompt) {
    if (prompt.url) return prompt.url;

    const params = new URLSearchParams();
    params.set('q', prompt.query || prompt.label);
    params.set('type', 'product');
    params.set('options[unavailable_products]', 'last');
    params.set('nbn_prompt', '1');
    return '/search?' + params.toString();
  }

  function clearPromptSearchState(input) {
    const params = new URLSearchParams(window.location.search);
    if (params.get('nbn_prompt') !== '1') return;

    const promptQuery = params.get('q') || '';
    if (!promptQuery || input.value !== promptQuery) return;

    input.value = '';
    input.setAttribute('placeholder', SEARCH_PLACEHOLDERS[0]);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    params.delete('nbn_prompt');
    const cleanSearch = params.toString();
    const cleanUrl = window.location.pathname + (cleanSearch ? '?' + cleanSearch : '') + window.location.hash;
    window.history.replaceState(window.history.state, '', cleanUrl);
  }

  function injectSearchPromptStyles() {
    if (document.getElementById('nbn-search-prompts-style')) return;

    const style = document.createElement('style');
    style.id = 'nbn-search-prompts-style';
    style.textContent = `
      .nbn-search-prompts {
        display: flex;
        flex-wrap: wrap;
        gap: 7px;
        margin: 8px 0 0;
        pointer-events: auto;
        position: relative;
        width: 100%;
        z-index: 5;
      }

      .nbn-search-prompt {
        appearance: none;
        border: 1px solid rgba(237, 3, 124, 0.28);
        border-radius: 999px;
        background: #fff;
        color: #2b2b2b;
        cursor: pointer;
        font: inherit;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.2;
        padding: 7px 10px;
        pointer-events: auto;
        position: relative;
        text-align: left;
        transition: background 160ms ease, border-color 160ms ease, color 160ms ease;
      }

      .nbn-search-prompt:hover,
      .nbn-search-prompt:focus-visible {
        background: #ed037c;
        border-color: #ed037c;
        color: #fff;
        outline: none;
      }

	      @media (max-width: 767px) {
	        .nbn-search-prompts {
	          background: #fff;
	          border-bottom: 1px solid rgba(237, 3, 124, 0.12);
	          box-shadow: none;
	          cursor: grab;
	          overflow-x: auto;
	          overflow-y: hidden;
	          flex-wrap: nowrap;
	          margin: 7px 0 0;
	          max-width: 100%;
	          min-width: 0;
	          padding: 8px 0 3px;
	          scroll-behavior: smooth;
	          scrollbar-width: none;
	          touch-action: pan-x;
	          -webkit-overflow-scrolling: touch;
	        }

	        .nbn-search-prompts.is-dragging {
	          cursor: grabbing;
	          scroll-behavior: auto;
	        }

	        .nbn-search-prompts::-webkit-scrollbar {
	          display: none;
	        }

        .nbn-search-prompt {
          flex: 0 0 auto;
          white-space: nowrap;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function enhanceSearchForms() {
	    injectSearchPromptStyles();

    document.querySelectorAll('.searchform form').forEach(function(form) {
      if (form.dataset.nbnSearchPrompts === 'true') return;

      const input = form.querySelector('input[type="search"][name="q"]');
      const formRow = form.querySelector('.searchform--form');
      if (!input || !formRow) return;

      form.dataset.nbnSearchPrompts = 'true';
      if (!input.value) {
        const index = Math.floor(Date.now() / 30000) % SEARCH_PLACEHOLDERS.length;
        input.setAttribute('placeholder', SEARCH_PLACEHOLDERS[index]);
      }

	      const promptWrap = document.createElement('div');
	      promptWrap.className = 'nbn-search-prompts';
	      promptWrap.setAttribute('aria-label', 'Popular search prompts');
	      let dragStartX = 0;
	      let dragStartY = 0;
	      let dragStartScrollLeft = 0;
	      let isPointerDragging = false;
	      let didDrag = false;
	      let dragResetTimer;

	      function scheduleDragReset() {
	        window.clearTimeout(dragResetTimer);
	        dragResetTimer = window.setTimeout(function() {
	          didDrag = false;
	        }, 160);
	      }

	      promptWrap.addEventListener('pointerdown', function(event) {
	        if (!window.matchMedia('(max-width: 767px)').matches) return;

	        dragStartX = event.clientX;
	        dragStartY = event.clientY;
	        dragStartScrollLeft = promptWrap.scrollLeft;
	        isPointerDragging = true;
	        didDrag = false;
	        promptWrap.classList.add('is-dragging');
	        if (promptWrap.setPointerCapture) {
	          promptWrap.setPointerCapture(event.pointerId);
	        }
	      });

	      promptWrap.addEventListener('pointermove', function(event) {
	        if (!isPointerDragging) return;

	        const dragDistance = event.clientX - dragStartX;
	        const verticalDistance = event.clientY - dragStartY;
	        if (Math.abs(dragDistance) > 4 && Math.abs(dragDistance) > Math.abs(verticalDistance)) {
	          didDrag = true;
	          event.preventDefault();
	        }
	        promptWrap.scrollLeft = dragStartScrollLeft - dragDistance;
	      });

	      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function(eventName) {
	        promptWrap.addEventListener(eventName, function() {
	          isPointerDragging = false;
	          promptWrap.classList.remove('is-dragging');
	          scheduleDragReset();
	        });
	      });

	      promptWrap.addEventListener('touchstart', function(event) {
	        if (!window.matchMedia('(max-width: 767px)').matches || !event.touches.length) return;

	        dragStartX = event.touches[0].clientX;
	        dragStartY = event.touches[0].clientY;
	        dragStartScrollLeft = promptWrap.scrollLeft;
	        didDrag = false;
	        promptWrap.classList.add('is-dragging');
	      }, { passive: true });

	      promptWrap.addEventListener('touchmove', function(event) {
	        if (!event.touches.length) return;

	        const dragDistance = event.touches[0].clientX - dragStartX;
	        const verticalDistance = event.touches[0].clientY - dragStartY;
	        if (Math.abs(dragDistance) > 4 && Math.abs(dragDistance) > Math.abs(verticalDistance)) {
	          didDrag = true;
	          promptWrap.scrollLeft = dragStartScrollLeft - dragDistance;
	          event.preventDefault();
	        }
	      }, { passive: false });

	      ['touchend', 'touchcancel'].forEach(function(eventName) {
	        promptWrap.addEventListener(eventName, function() {
	          promptWrap.classList.remove('is-dragging');
	          scheduleDragReset();
	        }, { passive: true });
	      });

	      SEARCH_PROMPTS.forEach(function(prompt) {
	        const button = document.createElement('button');
	        button.type = 'button';
	        button.className = 'nbn-search-prompt';
	        button.dataset.nbnSearchUrl = buildSearchUrl(prompt);
	        button.textContent = prompt.label;
	        button.addEventListener('click', function(event) {
	          if (didDrag && Math.abs(promptWrap.scrollLeft - dragStartScrollLeft) > 8) {
	            event.preventDefault();
	            didDrag = false;
	            return;
	          }
	          input.value = prompt.query || prompt.label;
	          window.location.assign(button.dataset.nbnSearchUrl);
	        });
        promptWrap.appendChild(button);
      });

      formRow.insertAdjacentElement('afterend', promptWrap);
      clearPromptSearchState(input);
    });
  }

  function enhanceFleshlightGirlsLanding() {
    const path = window.location.pathname.replace(/\/$/, '');
    if (path !== '/collections/fleshlight-girls') return;

    if (!document.querySelector('.thb-full-menu a[href="/collections/fleshlight-girls"]')) {
      const sexToysItem = document.querySelector('.thb-full-menu > li[data-item-title*="Sex Toys"]');
      if (sexToysItem) {
        const item = document.createElement('li');
        item.setAttribute('role', 'none');
        item.className = 'active';
        item.innerHTML = '<a role="menuitem" href="/collections/fleshlight-girls" aria-current="page">Fleshlight Girls</a>';
        sexToysItem.insertAdjacentElement('afterend', item);
      }
    }

    if (!document.querySelector('#mobile-menu a[href="/collections/fleshlight-girls"]')) {
      const mobileItems = Array.from(document.querySelectorAll('#mobile-menu .mobile-menu > li'));
      const sexToysMobileItem = mobileItems.find(function(item) {
        const summary = item.querySelector('summary.parent-link');
        return summary && summary.textContent && summary.textContent.indexOf('Sex Toys') !== -1;
      });
      if (sexToysMobileItem) {
        const item = document.createElement('li');
        item.innerHTML = '<a href="/collections/fleshlight-girls" title="Fleshlight Girls">Fleshlight Girls</a>';
        sexToysMobileItem.insertAdjacentElement('afterend', item);
      }
    }

    if (!document.querySelector('.nbn-fleshlight-girls-bundle')) {
      const productGrid = document.querySelector('#ProductGridContainer');
      const bundle = document.createElement('section');
      bundle.className = 'nbn-fleshlight-girls-bundle';
      bundle.setAttribute('aria-labelledby', 'nbn-fleshlight-girls-bundle-title');
      bundle.setAttribute('data-nbn-fleshlight-girls-bundle', '');
      bundle.innerHTML = [
        '<div class="nbn-fleshlight-girls-bundle__copy">',
        '<p class="nbn-fleshlight-girls-bundle__eyebrow">Complete the bundle</p>',
        '<h2 id="nbn-fleshlight-girls-bundle-title">Add the essentials before checkout.</h2>',
        '<p>A Fleshlight feels better and lasts longer with the right lube, cleaner and renewing powder.</p>',
        '<button class="nbn-fleshlight-girls-bundle__toggle" type="button" aria-expanded="false" aria-controls="nbn-fleshlight-girls-bundle-items"><span>Complete the bundle</span><span class="nbn-fleshlight-girls-bundle__toggle-icon" aria-hidden="true">+</span></button>',
        '</div>',
        '<div class="nbn-fleshlight-girls-bundle__items" id="nbn-fleshlight-girls-bundle-items">',
        '<div class="nbn-fleshlight-girls-bundle__item"><div class="nbn-fleshlight-girls-bundle__top"><a class="nbn-fleshlight-girls-bundle__image-link" href="/products/fleshlube-water" aria-label="View Fleshlube Water"><img class="nbn-fleshlight-girls-bundle__image" src="//cdn.shopify.com/s/files/1/0579/7258/8717/files/4oz8oz-Water-Grid-1-732x820.png?v=1733714269&width=160" alt="Fleshlube Water" loading="lazy" width="72" height="72"></a><span class="nbn-fleshlight-girls-bundle__tag">Best first add-on</span></div><a class="nbn-fleshlight-girls-bundle__title" href="/products/fleshlube-water">Fleshlube Water</a><span class="nbn-fleshlight-girls-bundle__text">Water-based lube made to pair with Fleshlight sleeves.</span><form class="nbn-fleshlight-girls-bundle__form" action="/cart/add" method="post" data-nbn-bundle-add><input type="hidden" name="id" value="40961177977005"><input type="hidden" name="quantity" value="1"><button class="nbn-fleshlight-girls-bundle__button button accent" type="submit" aria-label="Add Fleshlube Water 4oz to cart">Add 4oz</button></form></div>',
        '<div class="nbn-fleshlight-girls-bundle__item"><div class="nbn-fleshlight-girls-bundle__top"><a class="nbn-fleshlight-girls-bundle__image-link" href="/products/wet-stuff-toy-cleaner" aria-label="View Wet Stuff Toy Cleaner"><img class="nbn-fleshlight-girls-bundle__image" src="//cdn.shopify.com/s/files/1/0579/7258/8717/products/2783540001_media-01.jpg?v=1634665033&width=160" alt="Wet Stuff Toy Cleaner" loading="lazy" width="72" height="72"></a><span class="nbn-fleshlight-girls-bundle__tag">Keep it fresh</span></div><a class="nbn-fleshlight-girls-bundle__title" href="/products/wet-stuff-toy-cleaner">Wet Stuff Toy Cleaner</a><span class="nbn-fleshlight-girls-bundle__text">Easy clean-up after use so the sleeve stays ready for next time.</span><form class="nbn-fleshlight-girls-bundle__form" action="/cart/add" method="post" data-nbn-bundle-add><input type="hidden" name="id" value="40961110573229"><input type="hidden" name="quantity" value="1"><button class="nbn-fleshlight-girls-bundle__button button accent" type="submit">Add to cart</button></form></div>',
        '<div class="nbn-fleshlight-girls-bundle__item"><div class="nbn-fleshlight-girls-bundle__top"><a class="nbn-fleshlight-girls-bundle__image-link" href="/products/fleshlight-renewing-powder" aria-label="View Renewing Powder"><img class="nbn-fleshlight-girls-bundle__image" src="//cdn.shopify.com/s/files/1/0579/7258/8717/products/fleshlube_powder_full-600x600.jpg?v=1635233531&width=160" alt="Fleshlight Renewing Powder" loading="lazy" width="72" height="72"></a><span class="nbn-fleshlight-girls-bundle__tag">Make it last</span></div><a class="nbn-fleshlight-girls-bundle__title" href="/products/fleshlight-renewing-powder">Renewing Powder</a><span class="nbn-fleshlight-girls-bundle__text">Restores the soft feel after washing and drying.</span><form class="nbn-fleshlight-girls-bundle__form" action="/cart/add" method="post" data-nbn-bundle-add><input type="hidden" name="id" value="40961629782189"><input type="hidden" name="quantity" value="1"><button class="nbn-fleshlight-girls-bundle__button button accent" type="submit">Add to cart</button></form></div>',
        '</div>'
      ].join('');
      if (productGrid) productGrid.insertAdjacentElement('beforebegin', bundle);
    }

    if (!document.querySelector('#nbn-fleshlight-girls-bundle-style')) {
      const style = document.createElement('style');
      style.id = 'nbn-fleshlight-girls-bundle-style';
      style.textContent = [
        '.nbn-fleshlight-girls-bundle{display:grid;grid-template-columns:minmax(0,.8fr) minmax(0,1.2fr);gap:18px;align-items:stretch;margin:0 0 22px;padding:18px;border:1px solid rgba(23,23,23,.12);border-radius:8px;background:#fff7fb;color:#171717;}',
        '.nbn-fleshlight-girls-bundle__copy{display:flex;flex-direction:column;justify-content:center;min-width:0;}',
        '.nbn-fleshlight-girls-bundle__eyebrow{margin:0 0 5px!important;color:#ed037c!important;font-size:12px!important;font-weight:900!important;line-height:1.2!important;text-transform:uppercase;letter-spacing:0!important;}',
        '.nbn-fleshlight-girls-bundle h2{margin:0 0 7px;color:#171717;font-size:24px;line-height:1.15;font-weight:950;letter-spacing:0;}',
        '.nbn-fleshlight-girls-bundle p{margin:0;color:#3d3d3d;font-size:14px;line-height:1.45;}',
        '.nbn-fleshlight-girls-bundle__toggle{display:none;}',
        '.nbn-fleshlight-girls-bundle__items{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;}',
        '.nbn-fleshlight-girls-bundle__item{display:flex;flex-direction:column;gap:8px;min-height:188px;padding:14px;border:1px solid rgba(23,23,23,.12);border-radius:8px;background:#fff;color:#171717;text-decoration:none;transition:border-color .18s ease,box-shadow .18s ease,transform .18s ease;}',
        '.nbn-fleshlight-girls-bundle__item:hover,.nbn-fleshlight-girls-bundle__item:focus-visible{border-color:#ed037c;box-shadow:0 8px 18px rgba(237,3,124,.12);transform:translateY(-1px);color:#171717;}',
        '.nbn-fleshlight-girls-bundle__top{display:flex;align-items:flex-start;gap:10px;}',
        '.nbn-fleshlight-girls-bundle__image-link{display:block;flex:0 0 72px;width:72px;height:72px;border:1px solid rgba(23,23,23,.1);border-radius:50%;background:#fff;overflow:hidden;}',
        '.nbn-fleshlight-girls-bundle__image{display:block;width:100%;height:100%;object-fit:cover;}',
        '.nbn-fleshlight-girls-bundle__title{font-size:16px;line-height:1.2;font-weight:950;color:#171717;text-decoration:none;}',
        '.nbn-fleshlight-girls-bundle__title:hover,.nbn-fleshlight-girls-bundle__title:focus-visible{color:#ed037c;}',
        '.nbn-fleshlight-girls-bundle__text{color:#4d4d4d;font-size:13px;line-height:1.35;}',
        '.nbn-fleshlight-girls-bundle__tag{align-self:flex-start;padding:4px 7px;border-radius:4px;background:#ffde59;color:#171717;font-size:11px;line-height:1;font-weight:900;}',
        '.nbn-fleshlight-girls-bundle__form{margin:auto 0 0;}',
        '.nbn-fleshlight-girls-bundle__button{width:100%;min-height:38px;padding:9px 12px;border-radius:5px;font-size:13px;font-weight:900;line-height:1.1;text-align:center;}',
        '.nbn-fleshlight-girls-bundle__button[disabled]{opacity:.72;cursor:default;}',
        '@media (max-width:900px){.nbn-fleshlight-girls-bundle{display:block;margin:0 0 12px;padding:0;overflow:hidden;}.nbn-fleshlight-girls-bundle__copy{display:block;padding:0;}.nbn-fleshlight-girls-bundle__copy>.nbn-fleshlight-girls-bundle__eyebrow,.nbn-fleshlight-girls-bundle h2,.nbn-fleshlight-girls-bundle__copy>p{display:none;}.nbn-fleshlight-girls-bundle__toggle{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;min-height:46px;padding:13px 14px;border:0;background:#fff7fb;color:#171717;font-size:15px;font-weight:950;line-height:1.15;text-align:left;}.nbn-fleshlight-girls-bundle__toggle-icon{display:flex;align-items:center;justify-content:center;flex:0 0 24px;width:24px;height:24px;border-radius:50%;background:#ed037c;color:#fff;font-size:18px;font-weight:900;line-height:1;}.nbn-fleshlight-girls-bundle.is-open .nbn-fleshlight-girls-bundle__toggle-icon{font-size:0;}.nbn-fleshlight-girls-bundle.is-open .nbn-fleshlight-girls-bundle__toggle-icon:before{content:"";width:10px;height:2px;border-radius:2px;background:#fff;}.nbn-fleshlight-girls-bundle__items{display:none;grid-template-columns:1fr;gap:10px;padding:0 14px 14px;}.nbn-fleshlight-girls-bundle.is-open .nbn-fleshlight-girls-bundle__items{display:grid;}.nbn-fleshlight-girls-bundle__item{min-height:0;}}'
      ].join('');
      document.head.appendChild(style);
    }
  }

  function bindFleshlightGirlsBundleToggle() {
    const mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;

    document.querySelectorAll('[data-nbn-fleshlight-girls-bundle]').forEach(function(bundle) {
      if (bundle.dataset.nbnBundleToggleBound === 'true') return;
      const toggle = bundle.querySelector('.nbn-fleshlight-girls-bundle__toggle');
      const items = bundle.querySelector('.nbn-fleshlight-girls-bundle__items');
      if (!toggle || !items) return;

      bundle.dataset.nbnBundleToggleBound = 'true';
      if (!items.id) items.id = 'nbn-fleshlight-girls-bundle-items';
      toggle.setAttribute('aria-controls', items.id);

      const setOpen = function(open) {
        bundle.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      const syncDefault = function() {
        if (mobileQuery && mobileQuery.matches) {
          if (!bundle.dataset.nbnUserToggled) setOpen(false);
        } else {
          setOpen(true);
        }
      };

      toggle.addEventListener('click', function() {
        bundle.dataset.nbnUserToggled = 'true';
        setOpen(!bundle.classList.contains('is-open'));
      });

      syncDefault();
      if (mobileQuery) {
        if (mobileQuery.addEventListener) {
          mobileQuery.addEventListener('change', syncDefault);
        } else if (mobileQuery.addListener) {
          mobileQuery.addListener(syncDefault);
        }
      }
    });
  }

  function bindFleshlightGirlsBundleCart() {
    if (window.__nbnFleshlightGirlsBundleCartBound) return;
    window.__nbnFleshlightGirlsBundleCartBound = true;

    document.addEventListener('submit', function(event) {
      const form = event.target.closest('[data-nbn-bundle-add]');
      if (!form || !window.fetch) return;

      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const originalText = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: new FormData(form)
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (button) button.textContent = 'Added';
          setTimeout(function() {
            if (button) {
              button.disabled = false;
              button.textContent = originalText;
            }
          }, 1800);
        })
        .catch(function() {
          form.submit();
        });
    });
  }

  function init() {
    injectBadges();
    enhanceSearchForms();
    enhanceFleshlightGirlsLanding();
    bindFleshlightGirlsBundleToggle();
    bindFleshlightGirlsBundleCart();

    // Watch for Brauz/JS rebuilds
    const observer = new MutationObserver(function() {
      if (!document.querySelector('.nbn-badges') && document.querySelector('.product-add-to-cart-container')) {
        setTimeout(injectBadges, 50);
      }
      enhanceSearchForms();
      enhanceFleshlightGirlsLanding();
      bindFleshlightGirlsBundleToggle();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Fallback retries
    setTimeout(injectBadges, 300);
    setTimeout(injectBadges, 800);
    setTimeout(injectBadges, 2000);
    setTimeout(injectBadges, 4000);
    setTimeout(enhanceFleshlightGirlsLanding, 300);
    setTimeout(enhanceFleshlightGirlsLanding, 800);
    setTimeout(enhanceFleshlightGirlsLanding, 2000);
    setTimeout(bindFleshlightGirlsBundleToggle, 300);
    setTimeout(bindFleshlightGirlsBundleToggle, 800);
    setTimeout(bindFleshlightGirlsBundleToggle, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
